<template>
  <div>
    <h3 class="field-label">{{ question.label }}</h3>
    <div class="flex flex-wrap field-value">
      <ul
       v-if="crossListedCourses.length"
       class="list-disc list-inside ml-4"
      >
        <li
          v-for="course in crossListedCourses"
          :key="course.courseId"
        >
          <NuxtLink
            :to="getCourseUrl(course)"
            :title="course.longName"
            class="mb-1 color-theme-light hover:color-theme-base underline transition-all duration-300 ease-in-out"
          >
            {{ course.code || course.subjectCode + course.courseNumber }}
          </NuxtLink>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CoursesService from '@/services/courses'
import useCourses from '@/composables/useCourses'

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    question: {
      type: Object,
      required: true,
    },
  },
  setup(props, { root }) {
    const api = new CoursesService(root.$axios, root.$store)
    const { getCourseUrl } = useCourses(root)

    return { api, getCourseUrl }
  },
  data() {
    return {
      crossListedCourses: [],
    }
  },
  computed: {
    ...mapGetters('settings', ['enableFetchingRequisitesWithLatestRevisions']),
  },
  watch: {
    value() {
      if (this.value && this.value.length) return this.loadCrossListedCourses()
    },
  },
  mounted() {
    // if this component is shown conditionally via field actions (eg shown only if there are any crosslisted courses) then
    // there's no change in value (render happens after setting value prop to its target value)
    // and the crosslisted course details are not fetched
    if (this.value && this.value.length) {
      this.loadCrossListedCourses()
    }
  },
  methods: {
    async loadCrossListedCourses() {
      const courseIds = this.value.map(
        (crossListedCourse) => crossListedCourse.entityId
      )
      this.crossListedCourses = await Promise.all(
        courseIds.map((courseId) => this.api.getCourse(courseId))
      )
      if (this.enableFetchingRequisitesWithLatestRevisions) {
        this.crossListedCourses = this.crossListedCourses.filter(Boolean)
      }
    },
  },
}
</script>
